import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { PermissionsApiService } from '../services/permissions-api-service';
import { PermissionsContext, PermissionsLoadingContext } from './permissions-context';

export function PermissionsProvider({ children, ...props }) {
  const [permissions, setPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { accounts } = useMsal();

  useEffect(() => {
    if (accounts.length === 0) return;
    new PermissionsApiService()
      .getPermissionsForSignedInUser()
      .then(data => setPermissions(data?.$values ?? []))
      .finally(() => setIsLoading(false));
  }, [accounts]);

  return (
    <PermissionsContext.Provider value={permissions} {...props}>
      <PermissionsLoadingContext.Provider value={isLoading}>
        {children}
      </PermissionsLoadingContext.Provider>
    </PermissionsContext.Provider>
  );
}
